const ArquivoService = {
    converterBlobParaBase64: async (blob) => {
        const file = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
          const base64 = file.replace(/^data:[a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+;base64,/, '');
          return base64;
    },

    /**
     * Converte um Blob de áudio (ex: webm/ogg gravado pelo navegador) para WAV.
     * Solução para áudios corrompidos no WhatsApp iOS quando originários do Chrome.
     */
    converterBlobParaWav: async (blob) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        try {
            const arrayBuffer = await blob.arrayBuffer();
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
            return await ArquivoService.audioBufferToWav(audioBuffer);
        } finally {
            audioContext.close();
        }
    },

    /**
     * Converte AudioBuffer para Blob WAV (formato universalmente compatível)
     * Solução para áudios corrompidos no WhatsApp iOS quando originários do Chrome
     */
    audioBufferToWav: async (audioBuffer) => {
        const numberOfChannels = audioBuffer.numberOfChannels;
        const sampleRate = audioBuffer.sampleRate;
        const format = 1; // PCM
        const bitDepth = 16;

        const bytesPerSample = bitDepth / 8;
        const blockAlign = numberOfChannels * bytesPerSample;

        // Extrair dados de áudio
        const channelData = [];
        for (let i = 0; i < numberOfChannels; i++) {
            channelData.push(audioBuffer.getChannelData(i));
        }

        // Calcular tamanho do arquivo
        const dataLength = audioBuffer.length * numberOfChannels * bytesPerSample;
        const buffer = new ArrayBuffer(44 + dataLength);
        const view = new DataView(buffer);

        const writeString = (offset, string) => {
            for (let i = 0; i < string.length; i++) {
                view.setUint8(offset + i, string.charCodeAt(i));
            }
        };

        const floatTo16BitPCM = (output, offset, input) => {
            for (let i = 0; i < input.length; i++, offset += 2) {
                const s = Math.max(-1, Math.min(1, input[i]));
                output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
            }
        };

        // Escrever cabeçalho WAV
        writeString(0, 'RIFF');
        view.setUint32(4, 36 + dataLength, true);
        writeString(8, 'WAVE');
        writeString(12, 'fmt ');
        view.setUint32(16, 16, true); // fmt chunk size
        view.setUint16(20, format, true);
        view.setUint16(22, numberOfChannels, true);
        view.setUint32(24, sampleRate, true);
        view.setUint32(28, sampleRate * blockAlign, true);
        view.setUint16(32, blockAlign, true);
        view.setUint16(34, bitDepth, true);
        writeString(36, 'data');
        view.setUint32(40, dataLength, true);

        // Interleavar dados dos canais (funciona para mono, estéreo ou mais canais)
        const interleaved = new Float32Array(audioBuffer.length * numberOfChannels);
        for (let frame = 0; frame < audioBuffer.length; frame++) {
            for (let channel = 0; channel < numberOfChannels; channel++) {
                interleaved[frame * numberOfChannels + channel] = channelData[channel][frame];
            }
        }
        floatTo16BitPCM(view, 44, interleaved);

        return new Blob([buffer], { type: 'audio/wav' });
    }
};

export default ArquivoService;
